"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from "react";
import { useSearchParams } from "next/navigation";
import { useFilterQuery } from "@/hooks/useFilterQuery";
import { parseSearchInitialState } from "./searchInitialState";
const FILTER_DEBOUNCE_MS = 350;
export function useSearchFilters() {
  const $ = _c(27);
  const {
    updateQuery
  } = useFilterQuery();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = parseSearchInitialState(searchParams);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const initial = t0;
  const [search, setSearch] = useState(initial.search);
  const [selectedGenres, setSelectedGenres] = useState(initial.selectedGenres);
  const [selectedCountries, setSelectedCountries] = useState(initial.selectedCountries);
  const [yearType, setYearType] = useState(initial.yearType);
  const [range, setRange] = useState(initial.range);
  const debounceTimerRef = useRef(null);
  let t1;
  if ($[2] !== updateQuery) {
    t1 = (key, value) => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      debounceTimerRef.current = setTimeout(() => {
        updateQuery(key, value);
      }, FILTER_DEBOUNCE_MS);
    };
    $[2] = updateQuery;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const debouncedUpdateQuery = t1;
  let t2;
  if ($[4] !== debouncedUpdateQuery) {
    t2 = value_0 => {
      setSearch(value_0);
      debouncedUpdateQuery("search", value_0);
    };
    $[4] = debouncedUpdateQuery;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleSearchChange = t2;
  let t3;
  if ($[6] !== debouncedUpdateQuery) {
    t3 = items => {
      setSelectedGenres(items);
      debouncedUpdateQuery("genres", items.join(","));
    };
    $[6] = debouncedUpdateQuery;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleGenresChange = t3;
  let t4;
  if ($[8] !== debouncedUpdateQuery) {
    t4 = items_0 => {
      setSelectedCountries(items_0);
      debouncedUpdateQuery("countries", items_0.join(","));
    };
    $[8] = debouncedUpdateQuery;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleCountriesChange = t4;
  let t5;
  if ($[10] !== updateQuery) {
    t5 = type => {
      setYearType(type);
      updateQuery("year", "");
      if (type === "gregorian") {
        setRange([1950, 2026]);
      } else {
        setRange([1329, 1404]);
      }
    };
    $[10] = updateQuery;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleYearType = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = val => {
      setRange(val);
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleRangeChange = t6;
  let t7;
  if ($[13] !== debouncedUpdateQuery) {
    t7 = val_0 => {
      debouncedUpdateQuery("year", `${val_0[0]}-${val_0[1]}`);
    };
    $[13] = debouncedUpdateQuery;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleRangeChangeFinal = t7;
  let t8;
  if ($[15] !== handleCountriesChange || $[16] !== handleGenresChange || $[17] !== handleRangeChangeFinal || $[18] !== handleSearchChange || $[19] !== handleYearType || $[20] !== range || $[21] !== search || $[22] !== selectedCountries || $[23] !== selectedGenres || $[24] !== updateQuery || $[25] !== yearType) {
    t8 = {
      search,
      selectedGenres,
      selectedCountries,
      yearType,
      range,
      updateQuery,
      handleSearchChange,
      handleGenresChange,
      handleCountriesChange,
      handleYearType,
      handleRangeChange,
      handleRangeChangeFinal
    };
    $[15] = handleCountriesChange;
    $[16] = handleGenresChange;
    $[17] = handleRangeChangeFinal;
    $[18] = handleSearchChange;
    $[19] = handleYearType;
    $[20] = range;
    $[21] = search;
    $[22] = selectedCountries;
    $[23] = selectedGenres;
    $[24] = updateQuery;
    $[25] = yearType;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  return t8;
}